<template>
  <v-layout 
	column
	pt-5
	mt-4>
    <v-flex
      v-if="isUserLoggedIn"
		xs12
		md6
		lg4
		pa-1
    >
      <users-search-panel />
    </v-flex>
    <v-flex
		xs12
		md6
		lg4
		pa-1
    >
      <users-panel />
    </v-flex>
  </v-layout>
</template>

<script>
import UsersPanel from './UsersPanel'
import UsersSearchPanel from './UsersSearchPanel'
import UsersService from '@/services/UsersService'
import {mapState} from 'vuex'

export default {
	components: {
		UsersPanel,
		UsersSearchPanel
	},
	data () {
		return {
			users: null
		}
	},
	computed: {
		...mapState([
			'isUserLoggedIn', 'user'
		])
	},
	async mounted () {
		if (!this.isUserLoggedIn) {
			this.$router.push({
				name: 'login'
			})
		}
		if (this.user.role === 'Master') {
					this.$router.push({
						name: 'clients'
					})
				}



		this.users = (await UsersService.index()).data
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/UsersIndex.vue